











































import {
  IWorkflowFormFieldOptionData,
  IWorkflowFormSectionFieldData
} from '@/models';
import { ErrorManager } from '@/models/error';
import { IFetchFormFieldOptionTodosParams } from '@/services';
import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';

import WorkflowFormBuilderOptionTabWindow from '../WorkflowFormBuilderOptionTabWindow.vue';
import WorkflowFormBuilderTodoTabDrawer from '../WorkflowFormBuilderTodoDrawer.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { PropertyTabs } from '../WorkflowFormBuilderPropertiesDrawer.vue';
import { extractTextFromHtml } from '@/utils/helpers';

export default Vue.extend({
  name: 'WorkflowFormBuilderOptionTab',

  components: {
    WorkflowFormBuilderOptionTabWindow,
    WorkflowFormBuilderTodoTabDrawer,
    ErrorAlert
  },

  props: {
    sectionField: Object as PropType<IWorkflowFormSectionFieldData>,
    templateId: Number,
    revisionId: Number
  },

  data() {
    return {
      PropertyTabs,
      selectedOption: null as null | IWorkflowFormFieldOptionData,

      loading: false,
      errorMessage: '',
      detailErrorMessage: '',

      drawer: false
    };
  },

  mounted() {
    this.loadFieldOptionsTodos();
  },

  methods: {
    ...mapActions({
      fetchWorkflowFormFieldOptionTodos:
        'workflowFormTemplate/fetchWorkflowFormFieldOptionTodos'
    }),
    extractTextFromHtml,

    loadFieldOptionsTodos() {
      const params: IFetchFormFieldOptionTodosParams = {
        templateId: this.templateId,
        revisionId: this.revisionId,
        sectionFieldId: this.sectionField.id
      };

      this.loading = true;

      this.fetchWorkflowFormFieldOptionTodos({ params })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    },

    openTodoDrawer(option: IWorkflowFormFieldOptionData) {
      this.selectedOption = option;
      this.drawer = true;
    },

    clearAllErrors() {
      this.detailErrorMessage = '';
      this.errorMessage = '';
    },

    save() {
      this.$emit('save');
    },

    goToTabWindow(tab: PropertyTabs) {
      this.$emit('goToTabWindow', tab);
    }
  }
});
